import React from 'react';
import styles from './Hero.module.css';
import avatar from '../../assets/avatar.png';
import { useTranslation } from 'react-i18next';

export const Hero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.hero}>
      <div className={styles.content}>
      <h1>
  {t('hero.title')} <span className={styles.name}>{t('hero.name')}</span>
</h1>
        <p className={styles.subtitle}>
          {t('hero.subtitle')}
        </p>
        <a href="#projekte" className={styles.cta}>{t('hero.cta')}</a>
      </div>

      <div className={styles.imageContainer}>
        <img src={avatar} alt="Avatar" className={styles.avatar} />
      </div>
    </section>
  );
};
